import IFilter from "./IFilter";
import { getMongoOperator } from "./utils/mongo.utils";
import ObjectIdFactory from "./ObjectIdFactory";

/**
 * This class handle the operator IN
 * @author Reynaldo
 * Example
 * {
 "type": "IN",
 "field": "operator"
 "value?": ["bb4cd88-c6b8-4a77-956a-0671189be008"]
 "values?": ["bb4cd88-c6b8-4a77-956a-0671189be008"]
 }
 * Result toMongoQuery
 * { "operator": { $in: ["bb4cd88-c6b8-4a77-956a-0671189be008"] } }
 **/

export default class InFilter extends IFilter {
  /**
   * @param filter {Object}
   **/
  constructor(filter) {
    super();
    const { field, value, values, objectId, isDate } = filter;
    this.type = "IN";
    this.field = field;
    this.value = value || values || [];
    this.filterObject = filter;
    this.objectId = objectId || false;
    this.isDate = isDate || false;
  }

  clone() {
    return new InFilter(this.toQuery());
  }

  toQuery() {
    if (!this.field) return this.filterObject;
    if (this.value === undefined) return;
    return {
      type: "IN",
      field: this.field,
      value: this.value,
      objectId: this.objectId,
      isDate: this.isDate,
    };
  }

  toMongoQuery() {
    if (!this.field) return this.filterObject;
    let nValues = this.value;
    if (this.objectId) {
      nValues = this.value.map((value) => ObjectIdFactory.create(value));
    }
    if (this.isDate) {
      nValues = nValues = this.value.map((value) =>
        Date.parse(value) ? new Date(value) : value
      );
    }
    return { [this.field]: { [getMongoOperator(this.type)]: nValues } };
  }
}
